import {
  useCallback,
  ChangeEvent,
  useState,
}                          from 'react';
import { EBodyStyle }      from '@enums/auction';
import { useFetchVinData } from '@modules/auctions/queries/auctionsQueries';

export interface IVinDecodeResult {
  vehicleBodyStyle : EBodyStyle;
  carBrandName     : string;
  carModelName     : string;
  year             : number;
}

export interface IVinDecodeParams {
  cuid : string;
  vin  : string;
}

interface IReturnProps {
  onInputVinCode : (event: ChangeEvent<HTMLInputElement>, cuid: string) => void;
  isLoading      : boolean;
}

const vinCodeRegex = new RegExp('[\\d\\w]{17}');

export const useDecodeVinCode = (
  onSuccessDecodeVin : (vinDecodeResult: IVinDecodeResult) => void,
  onErrorDecodeVin   : () => void,
): IReturnProps => {
  const [vinCode, setVinCode] = useState('');

  const { isLoading } = useFetchVinData(vinCode, {
    enabled   : !!vinCode,
    onError   : onErrorDecodeVin,
    onSuccess : (data = {} as IVinDecodeResult) => {
      onSuccessDecodeVin(data);
      setVinCode('');
    },
  });

  const onInputVinCode = useCallback(
    (event: ChangeEvent<HTMLInputElement>, cuid: string): void => {
      const { value: vin } = event.target;
      const isValidVinCode = vinCodeRegex.test(vin) && !!cuid;

      if (isValidVinCode) {
        setVinCode(vin);
      } else {
        onErrorDecodeVin();
      }
    },
    [onErrorDecodeVin],
  );

  return {
    onInputVinCode,
    isLoading,
  };
};
